import { COOKIE_KEYS } from '~/common/data/cookie-keys.data';
import { ThemeMode } from '~/common/types/theme.type';
import { getCookie } from '~/common/utils/cookie.util';

/**
 * 쿠키에서 저장된 테마 모드 조회
 */
export function getStoredThemeMode(): ThemeMode {
  const savedMode = getCookie(COOKIE_KEYS.THEME_MODE);
  if (savedMode === ThemeMode.DARK || savedMode === ThemeMode.LIGHT) {
    return savedMode as ThemeMode;
  }
  return ThemeMode.LIGHT;
}
